import report_page from './_report.js'
import project_page from './_project.js'
import product_page from './_product.js'
import app_page from './_app.js'
import money_page from './_money.js'
import order_page from './_order.js'
import merchant_page from './_merchant.js'
import channel_page from './_channel.js'
import workorder_page from './_workorder.js'

function megarr(a, b) {
  for (var i in b) {
    a.push(b[i])
  }
  return a
}

var def_page = [{
  path: 'mainpage/:leftid',
  name: 'backend_mainpage',
  component: () => import('@/views/backend/admin/mainpage/wait'),
  meta: {
    tpflag: 'backend',
    title: '控制台系统主页',
  }
}, {
  path: 'backlog/:leftid/:parent_id',
  name: 'backend_backlog',
  component: () => import('@/views/backend/admin/mainpage/backlog/list'),
  meta: {
    tpflag: 'backend',
    title: '待办事项',
  }
}, {
  path: 'sysconfig/:leftid/:parent_id',
  name: 'backend_sysconfig',
  component: () => import('@/views/backend/setting/sysconfig/index'),
  meta: {
    tpflag: 'backend',
    title: '系统设置',
  }
}, {
  path: 'agreementconfig/:leftid/:parent_id',
  name: 'backend_agreementconfig',
  component: () => import('@/views/backend/setting/agreementconfig/list'),
  meta: {
    tpflag: 'backend',
    title: '协议设置',
  }
}, {
  path: 'notificationconfig/:leftid/:parent_id',
  name: 'backend_notificationconfig',
  component: () => import('@/views/backend/setting/notificationconfig/list'),
  meta: {
    tpflag: 'backend',
    title: '版本更新',
  }
}, {
  path: 'orderconfig/:leftid/:parent_id',
  name: 'backend_orderconfig',
  component: () => import('@/views/backend/setting/orderconfig/index'),
  meta: {
    tpflag: 'backend',
    title: '订单设置',
  }
}, {
  path: 'projectconfig/:leftid/:parent_id',
  name: 'backend_projectconfig',
  component: () => import('@/views/backend/setting/projectconfig/index'),
  meta: {
    tpflag: 'backend',
    title: '项目设置',
  }
}, {
  path: 'moneyconfig/:leftid/:parent_id',
  name: 'backend_moneyconfig',
  component: () => import('@/views/backend/setting/moneyconfig/index'),
  meta: {
    tpflag: 'backend',
    title: '资金设置',
  }
}, {
  path: 'channelconfig/:leftid/:parent_id',
  name: 'backend_channelconfig',
  component: () => import('@/views/backend/setting/channelconfig/index'),
  meta: {
    tpflag: 'backend',
    title: '渠道设置',
  }
}, {
  path: 'workorderconfig/:leftid/:parent_id',
  name: 'backend_workorderconfig',
  component: () => import('@/views/backend/setting/workorderconfig/index'),
  meta: {
    tpflag: 'backend',
    title: '工单设置',
  }
}, {
  path: 'merchantconfig/:leftid/:parent_id',
  name: 'backend_merchantconfig',
  component: () => import('@/views/backend/setting/merchantconfig/index'),
  meta: {
    tpflag: 'backend',
    title: '商家设置',
  }
}, {
  path: 'operatelog/:leftid/:parent_id',
  name: 'backend_operatelog',
  component: () => import('@/views/backend/setting/operatelog/list'),
  meta: {
    tpflag: 'backend',
    title: '操作记录',
  }
}, {
  path: 'roleconfig/:leftid/:parent_id',
  name: 'backend_roleconfig',
  component: () => import('@/views/backend/setting/roleconfig/list'),
  meta: {
    tpflag: 'backend',
    title: '账号权限',
  }
}, {
  path: 'userdetail/:leftid/:parent_id',
  name: 'backend_userdetail',
  component: () => import('@/views/backend/setting/userconfig/user_detail'),
  meta: {
    tpflag: 'backend',
    title: '个人资料',
  }
}, {
  path: 'authsuccess/:leftid/:parent_id',
  name: 'backend_authsuccess',
  component: () => import('@/views/backend/setting/userconfig/wechat'),
  meta: {
    tpflag: 'backend',
  },
}, {
  path: 'alimsgconfig/:leftid/:parent_id',
  name: 'backend_alimsgconfig',
  component: () => import('@/views/backend/setting/alimsgconfig/index'),
  meta: {
    tpflag: 'backend',
    title: '阿里云短信配置',
  }
}]

def_page = megarr(def_page, report_page)
def_page = megarr(def_page, project_page)
def_page = megarr(def_page, product_page)
def_page = megarr(def_page, app_page)
def_page = megarr(def_page, money_page)
def_page = megarr(def_page, order_page)
def_page = megarr(def_page, merchant_page)
def_page = megarr(def_page, channel_page)
def_page = megarr(def_page, workorder_page)

export default def_page



// WEBPACK FOOTER //
// ./src/router/kdsuper/_kdsuper_children.js